module.exports = __webpack_public_path__ + "img/new.97cf7379.png";